import { registerModal } from 'features/Modal/ModalRegistry'
import NumbersCallPlanModal from './NumbersCallPlanModal'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'NUMBERS_CALL_PLAN_MODAL'
registerModal(modalType, NumbersCallPlanModal)

export default modalProps =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {
      fullScreen: true,
    },
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersCallPlanModal/NumbersCallPlanModal.action.js